import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { createStore } from "redux";
import { persistStore } from "redux-persist";
import { PersistGate } from "redux-persist/integration/react";
import App from "./App";
import AppReducer from "./Redux/Reducers";
import * as serviceWorker from "./serviceWorker";
import "./Style/style.scss";

import { AppThemeProvider } from "./theme/ThemeProvider";

const store = createStore(AppReducer);
const persistor = persistStore(store);

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <React.StrictMode>
        <AppThemeProvider>
          <App />
        </AppThemeProvider>
      </React.StrictMode>
    </PersistGate>
  </Provider>,
  document.getElementById("root")
);

// Keep service worker as before
serviceWorker.register(toast);
